import React from "react";
import Card from "../common/Card";
import CardSkeleton from "../common/CardSkeleton";
import ShowMore from "../common/ShowMore";
import axios from "axios";
import { useQuery } from "react-query";

const FeaturedJobs = React.memo(function FeaturedJobs() {
  const { data, isLoading } = useQuery({
    queryKey: ["featuredJobs"],
    queryFn: async () => {
      const options = {
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/job",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          list: "featured",
        },
      };

      const response = await axios.request(options);
      return response.data.data;
    },
  });

  /*console.log(data)*/
  return (
    <div className="container">
      <div className="inner-content">
        <div className="row recent-jobs">
          <div className="col-12 text-center">
            <h3 className="featured-business-title">Recent Jobs</h3>
          </div>
          {isLoading
            ? // Show 3 skeleton cards while loading
              Array.from({ length: 3 }).map((_, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6" key={`skeleton-${index}`}>
                  <CardSkeleton />
                </div>
              ))
            : data &&
              data.map((element, index) => {
                return (
                  <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                    <Card title={element.name ? element.name : ""} location={element.location ? element.location : ""} postalcode={element.postal_code ? element.postal_code : ""} page={element.page ? element.page : ""} type={element.type ? element.type.charAt(0).toUpperCase() + element.type.slice(1) : ""} salary={element.salary_value ? element.salary_value : false} desc={element.detail ? element.detail : ""} detail_url={element.page + "/" + element.slug} views={element.views} />
                  </div>
                );
              })}
          <ShowMore url={"/search?category=2&location=1&page=1&limit=10"} />
        </div>
      </div>
    </div>
  );
});

export default FeaturedJobs;
